const slugify = (str) => {
  return String(str)
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9 -]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
};

(($) => {
  $(document).ready(() => {
    const $infoNextButton = $('button[data-product-form-info-next-button]');
    const $form = $infoNextButton.closest('form[action*="/cart/add"]');
    const $wrapper = $form.closest('.wrapper');
    const $emailInput = $form.find('#productSelect-email');
    const $surgeryDateInput = $form.find('#productSelect-surgery-date');
    const $surgeryTypeInput = $form.find('#productSelect-surgery-type');
    const $infoStep = $form.find('[data-product-form-step-info]');
    const $atcStep = $form.find('[data-product-form-step-atc]');
    const sectionId = $form
      .closest('[data-section-id]')
      .attr('data-section-id');
    const $productObjectScript = $(`#ProductJson-${sectionId}`);
    const productObject = JSON.parse($productObjectScript.html() || null);
    let isSubmitting = false;

    $surgeryTypeInput.closest('.selector-wrapper').show();

    $surgeryDateInput.datepicker({
      minDate: +1,
      maxDate: '+12M',
      dateFormat: 'yy-mm-dd'
    });

    $form.on('keyup change', () => {
      const isButtonEnabled =
        !!$emailInput.val().trim() && !!$surgeryDateInput.val().trim();
      $infoNextButton.prop('disabled', !isButtonEnabled);
    });

    $infoNextButton.on('click', (e) => {
      e.preventDefault();

      if (!$emailInput.val().trim() || !$surgeryDateInput.val().trim()) {
        alert('Email address and surgery date are required!');
        return;
      }

      $infoStep.hide();

      $wrapper.get(0).scrollIntoView({
        behavior: 'smooth'
      });

      $atcStep.fadeIn(300);

      isSubmitting = true;

      fetch(
        'https://6ggthhd9j9.execute-api.us-east-1.amazonaws.com/dev/subscribe-patient-to-klaviyo',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            email: $emailInput.val().trim(),
            surgeryDate: $surgeryDateInput.val().trim(),
            surgeryType: $surgeryTypeInput.val().trim(),
            product: productObject
          })
        }
      ).finally(() => {
        isSubmitting = false;
      });
    });

    $(window).on('beforeunload', (e) => {
      if (isSubmitting === true) {
        e.preventDefault();
        return (e.returnValue = '');
      }
    });

    initSurgeonForm();
    initRedirectTimer();
  });

  function initSurgeonForm() {
    const $surgeonForm = $('#surgeon-form');

    if ($surgeonForm.length === 0) {
      return;
    }

    const $surgeonSelector = $('#surgeon-selector');

    const placeholder = $surgeonSelector.attr('title');
    const searchPlaceholder = $surgeonSelector.attr('data-search-placeholder');

    let surgeonData = [];

    $.get(window.ONB.surgeonsDataUrl, (csv) => {
      surgeonData = $.csv.toObjects(csv).map((item) => {
        item.doctors = item.doctors
          .split(',')
          .map((doctor) => doctor.trim())
          .filter((doctor) => !!doctor);
        return item;
      });

      const select2Data = surgeonData
        .filter((item) => item.active.toLowerCase() === 'true')
        .map((item) => {
          if (item.doctors && item.doctors.length > 0) {
            return {
              text: `${item.accountName}${
                item.accountLocation ? `, ${item.accountLocation}` : ''
              }`,
              children: item.doctors.map((doctor) => ({
                id: `${slugify(item.accountName)}-${slugify(doctor)}`,
                text: `${doctor}${
                  item.accountLocation ? `, ${item.accountLocation}` : ''
                }`,
                accountName: item.accountName,
                accountLocation: item.accountLocation,
                doctor: doctor
              }))
            };
          }

          return {
            id: slugify(item.accountName),
            text: `${item.accountName}${
              item.accountLocation ? `, ${item.accountLocation}` : ''
            }`,
            accountName: item.accountName,
            accountLocation: item.accountLocation
          };
        });

      select2Data.unshift({
        id: '',
        text: 'Select your surgeon'
      });

      $surgeonSelector.select2({
        data: select2Data,
        allowClear: true,
        placeholder: placeholder,
        minimumInputLength: 2,
        dropdownCssClass: 'surgeon-form__dropdown',
        matcher: (params, data) => {
          if (params.term.trim() === '') {
            return null;
          }

          if (typeof data.children === 'undefined') {
            return data.text
              .toLowerCase()
              .replace('dr. ', '')
              .indexOf(params.term.toLowerCase()) !== -1
              ? data
              : null;
          }

          var filteredChildren = [];
          $.each(data.children, function (idx, child) {
            if (
              data.text
                .toLowerCase()
                .replace('dr. ', '')
                .indexOf(params.term.toLowerCase()) !== -1 ||
              child.text
                .toLowerCase()
                .replace('dr. ', '')
                .indexOf(params.term.toLowerCase()) !== -1
            ) {
              filteredChildren.push(child);
            }
          });

          if (filteredChildren.length) {
            var modifiedData = $.extend({}, data, true);
            modifiedData.children = filteredChildren;

            return modifiedData;
          }

          return null;
        }
      });

      $surgeonForm.css('visibility', 'visible');
    });

    $surgeonForm.on('submit', (e) => {
      e.preventDefault();

      const selectedSurgeon = $surgeonSelector.select2('data')[0];

      const selectedSurgeonData = surgeonData.find((surgeon) =>
        selectedSurgeon.doctor
          ? surgeon.doctors.findIndex(
              (doctor) =>
                selectedSurgeon.accountName === surgeon.accountName &&
                selectedSurgeon.doctor === doctor
            ) !== -1
          : selectedSurgeon.accountName === surgeon.accountName
      );

      if (selectedSurgeonData) {
        let rootUrl = '';

        if (selectedSurgeonData.market.toLowerCase() === 'ca') {
          rootUrl = '/en-ca';
        }

        const productUrl = `${rootUrl}/products/${
          selectedSurgeonData.productHandle
        }?${selectedSurgeonData.secretLink}&surgeon=${
          selectedSurgeon.doctor || selectedSurgeon.accountName
        }`;

        window.location.href = productUrl;
      }
    });

    const isTouchDevice =
      'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0;

    $(document).on('select2:open', (e) => {
      const selectId = e.target.id;

      const $searchField = $(
        `.select2-search__field[aria-controls="select2-${selectId}-results"]`
      );

      $searchField.attr('placeholder', searchPlaceholder);

      if (isTouchDevice === false) {
        $searchField.each((key, value) => {
          value.focus();
        });
      }
    });
  }

  function initRedirectTimer() {
    const $redirectTimers = $('[data-redirect-timer]');
    $redirectTimers.each((i, redirectTimer) => {
      const $timer = $(redirectTimer);
      let time = parseInt($timer.data('redirect-time'));
      const url = $timer.data('redirect-url');

      if (time > 0) {
        $timer.text(time);

        const interval = setInterval(() => {
          $timer.text(time);

          if (time === 0) {
            if (url) {
              window.location.href = url;
            }

            clearInterval(interval);
          }

          time = time - 1;
        }, 1000);
      }
    });
  }
})(jQuery);
